import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { DatePivotParams } from "../../entities/date_pivot_params";
import { defaultChartViewerConfig } from "./default_chart_viewer_config";
import { createInventoryHealthMatrix } from "../../utils/inventory_health_matrix";

export const RawInventoryHealthContainer = () => {
  // Customer-specific date hierarchy configurations
  const dateHierarchyColumnFilter = {
    week: "week",
    month: "month",
    day: "day",
  };

  // Hardcoded measure options for the dropdown
  const measureColumnFilter = (params: DatePivotParams) => {
    const dateHierarchy =
      params.dateHierarchy.charAt(0).toUpperCase() +
      params.dateHierarchy.slice(1) +
      "s";
    return {
      "Purchase Order To Place": "Purchase Order To Place",
      "raw purchase need": "Raw Purchase Need",
      "Starting Inventory On Hand": "Starting Inventory On Hand",
      "Forecasted Sales": "Forecasted Sales",
      "purchase order arrivals": "PO Arrivals",
      "Ending Inventory On Hand": "Ending Inventory On Hand",
      "Unfulfilled Demand": "Unfulfilled Demand",
      [`Target ${dateHierarchy} of Supply`]: `Target ${dateHierarchy} of Supply`,
      [`Starting ${dateHierarchy} of Supply`]: `Starting ${dateHierarchy} of Supply`,
      [`Ending ${dateHierarchy} of Supply`]: `Ending ${dateHierarchy} of Supply`,
      "In Stock Rate": "In Stock Rate",
    };
  };

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_test",
        transformId: "raw_inventory_health",
        folder: "outputs",
        title: "Inventory Health",
        dateHierarchyColumnFilter,
        excludedSegmentationsFilter: [],
        measureColumnFilter,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.EnableChartView,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createInventoryHealthMatrix,
        chunkedMatrixTransformId: "raw_inventory_health_matrix",
        excludeDetailRows: true,
      }}
      defaultConfig={defaultConfig}
      chartConfig={defaultChartViewerConfig}
    />
  );
};
